"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COURSE_ENTITY_INDEX_TYPES = void 0;
var COURSE_ENTITY_INDEX_TYPES;
(function (COURSE_ENTITY_INDEX_TYPES) {
    COURSE_ENTITY_INDEX_TYPES["course"] = "course";
    COURSE_ENTITY_INDEX_TYPES["section"] = "section";
    COURSE_ENTITY_INDEX_TYPES["content"] = "content";
    COURSE_ENTITY_INDEX_TYPES["module"] = "module";
    COURSE_ENTITY_INDEX_TYPES["examQuestion"] = "exam-question";
})(COURSE_ENTITY_INDEX_TYPES = exports.COURSE_ENTITY_INDEX_TYPES || (exports.COURSE_ENTITY_INDEX_TYPES = {}));
//# sourceMappingURL=CourseEntityIndex.js.map